// extracted by mini-css-extract-plugin
module.exports = {"mobile":"768","tablet":"1024","zIndexModalSup":"1000"};